import { useNavigate } from 'react-router-dom'
import { Vars } from '@carrent/ui'
import { RUB } from './format'

/**
 * Гаджет: структура ремонтов.
 *
 * Разрез по типу работ, а не по узлу агрегата: «кузовные работы»
 * не отвечают, полетела коробка или подвеска. Называем как есть,
 * чтобы по этим данным не делали выводов о надёжности узлов.
 */
export function RepairBreakdownWidget({ data }) {
  const navigate = useNavigate()

  if (!data.total) {
    return <p className="widget-empty">За период ремонтов не было</p>
  }

  const max = Math.max(...data.types.map((t) => t.count), 1)

  return (
    <div className="repairs">
      <ul className="repairs__types">
        {data.types.map((t) => (
          <li key={t.key} className="repairs__type">
            <span className="repairs__type-label">{t.label}</span>
            <span className="repairs__track">
              <Vars
                as="span"
                className="repairs__bar"
                vars={{ '--bar-w': `${(t.count / max) * 100}%` }}
              />
            </span>
            <span className="repairs__count">{t.count}</span>
            <span className="repairs__cost">
              {t.cost > 0 ? `${RUB.format(t.cost)} ₽` : '—'}
            </span>
          </li>
        ))}
      </ul>

      {data.repeats.length > 0 && (
        <>
          <p className="repairs__repeats-title">
            Повторные обращения — стоит посмотреть
          </p>
          <ul className="widget-list">
            {data.repeats.map((r, i) => (
              <li key={`${r.car_id}-${i}`}>
                <button
                  type="button"
                  className="repairs__repeat"
                  onClick={() => navigate(`/admin/cars/${r.car_id}?tab=repairs`)}
                >
                  <span className="repairs__repeat-car">
                    {r.car}
                    {r.plate ? <span className="plate">{r.plate}</span> : null}
                  </span>
                  <span className="repairs__repeat-type">{r.type}</span>
                  <span className="repairs__repeat-count">{r.count} раза</span>
                </button>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
